module.exports = _.words;